module.exports = __webpack_public_path__ + "static/media/Breathe.0e0b3e6c.png";